import styled from 'styled-components';

export const Card = styled.div`
  .item-summary {
    min-width: 0;
    font-size: 14px;
  }

  .item-label {
    font-size: 16px;
    color: ${(props) => props.theme.$dark};
  }

  .btn-star {
    color: ${(props) => props.theme.$gray500};
    line-height: 1;

    &:hover {
      color: ${(props) => props.theme.$warning};
    }

    .material-icons {
      font-size: 22px;
    }
  }

  .btn-expand {
    width: 32px;
    height: 32px;

    .material-icons {
      font-size: 20px;
    }
  }
`;
